export default function CultureCTA() {
  return (
    <section className="py-24 bg-gradient-to-br from-teal-600 to-cyan-600">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <div className="mb-8">
          <i className="ri-heart-pulse-line text-white text-6xl"></i>
        </div>
        <h2 className="text-5xl font-bold text-white mb-6 leading-tight">
          Join Our Culture of Excellence
        </h2>
        <p className="text-white/90 text-xl mb-10 max-w-3xl mx-auto leading-relaxed">
          Be part of a team that values innovation, quality, collaboration, and courage. Together, we're shaping the future of healthcare and making a meaningful difference in people's lives.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <button
            onClick={() => window.REACT_APP_NAVIGATE('/about')}
            className="bg-white text-teal-600 px-8 py-4 rounded-full font-semibold text-lg hover:bg-gray-100 transition-all duration-300 shadow-xl hover:shadow-2xl hover:-translate-y-1 whitespace-nowrap cursor-pointer"
          >
            Learn About Us
          </button>
          <button
            onClick={() => window.REACT_APP_NAVIGATE('/')}
            className="bg-teal-800 text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-teal-900 transition-all duration-300 shadow-xl hover:shadow-2xl hover:-translate-y-1 whitespace-nowrap cursor-pointer"
          >
            Explore Our Products
          </button>
        </div>

        <div className="grid md:grid-cols-4 gap-8 mt-16">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
            <div className="text-4xl font-bold text-white mb-2">500+</div>
            <div className="text-white/80 text-sm">Healthcare Partners</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
            <div className="text-4xl font-bold text-white mb-2">200+</div>
            <div className="text-white/80 text-sm">Team Members</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
            <div className="text-4xl font-bold text-white mb-2">15+</div>
            <div className="text-white/80 text-sm">Years Experience</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
            <div className="text-4xl font-bold text-white mb-2">28</div>
            <div className="text-white/80 text-sm">Quality Products</div>
          </div>
        </div>
      </div>
    </section>
  );
}
